import React from 'react'
import PropTypes from 'prop-types'

import Titlebar from 'core/components/Titlebar'
import WPArticle from 'core/components/WPArticle'
import ConversationPDF from './ConversationPDF'

const ConversationContent = props => {
  const hasPDF = props.conversation && (props.conversation.fields || {}).pdf_file

  return (
    <div
      className={`conversation-content ${props.conversation ? 'is-active' : ''} ${
        hasPDF ? 'mod-pdf' : ''
      }`}
    >
      {props.titlebar && <Titlebar {...props.titlebar} />}
      <div className="conversation-content-wrapper">
        {(() => {
          if (!props.conversation) return null
          if (hasPDF) return <ConversationPDF pdf={props.conversation.fields.pdf_file} />

          return (
            <WPArticle className="mod-slim-pad">
              <div className="conversation-article">
                <header>
                  <h2 className="conversation-article-title type-heading mod-md-head">
                    {props.conversation.post_title}
                  </h2>
                </header>
                <div
                  className="conversation-article-content"
                  dangerouslySetInnerHTML={{ __html: props.conversation.post_content }}
                ></div>
              </div>
            </WPArticle>
          )
        })()}
      </div>
    </div>
  )
}

ConversationContent.propTypes = {
  conversation: PropTypes.object
}

export default ConversationContent
